import React from 'react';
import { Alert, AlertTitle, Box, CircularProgress, Typography } from '@mui/material';

// Conferencia do laboratorio do FAD-01 (Sessao 29, 23/09/2026 - Walber).
// So mostra o que o motor respondeu em POST /api/fad01/validar-laboratorio.
// As regras moram no motor (app/utils/consistencia_lab.py) - nada e decidido aqui.
// Cores: so as do tema MUI (error / warning / success), para funcionar no claro e no escuro.

export interface ItemConferencia { regra: string; mensagem: string; }
export interface ResultadoConferencia { travas: ItemConferencia[]; avisos: ItemConferencia[]; }

interface Props {
  resultado: ResultadoConferencia | null;
  falhou: boolean;
  conferindo: boolean;
  temLaboratorio: boolean;
}

const linha = (i: ItemConferencia) => `${i.mensagem} (${i.regra})`;

export default function ConferenciaLaboratorio({ resultado, falhou, conferindo, temLaboratorio }: Props) {
  const travas = resultado?.travas ?? [];
  const avisos = resultado?.avisos ?? [];
  const temAlgo = travas.length > 0 || avisos.length > 0;

  if (!temLaboratorio && !temAlgo) return null;

  return (
    <Box sx={{ px: 2, pb: 2, pt: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography sx={{ fontWeight: 800, fontSize: '0.72rem', textTransform: 'uppercase',
          letterSpacing: '0.1em', color: 'text.secondary' }}>
          Conferência do laboratório
        </Typography>
        {conferindo && <CircularProgress size={12} />}
      </Box>

      {falhou && !resultado && (
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          Conferência indisponível — o sistema confere de novo ao salvar.
        </Typography>
      )}

      {travas.length > 0 && (
        <Alert severity="error" sx={{ mb: 1 }}>
          <AlertTitle sx={{ fontWeight: 700 }}>Não é possível salvar — corrija:</AlertTitle>
          <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
            {travas.map((t, i) => <li key={i}>{linha(t)}</li>)}
          </Box>
        </Alert>
      )}

      {avisos.length > 0 && (
        <Alert severity="warning" sx={{ mb: 1 }}>
          <AlertTitle sx={{ fontWeight: 700 }}>Atenção — confira:</AlertTitle>
          <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
            {avisos.map((a, i) => <li key={i}>{linha(a)}</li>)}
          </Box>
        </Alert>
      )}

      {resultado && !temAlgo && temLaboratorio && (
        <Alert severity="success" variant="outlined" sx={{ py: 0 }}>
          Laboratório consistente
        </Alert>
      )}
    </Box>
  );
}

export const textoItens = linha;
